import React from 'react';

import TooltipForReceptionist from 'components/TooltipForReceptionist';
import IN from 'constants/in';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import alwaysNoop from 'utils/functions/nullary/alwaysNoop.util';
import asObject from 'utils/objects/asObject.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';

import DropdowonContainer from 'onboarding/common/forms/common/Popup';
import InputFieldContainer from 'onboarding/common/InputField';
import PhoneNumberInput from 'onboarding/common/PhoneNumberInput';
import CategoryItem from 'onboarding/stylists/CategoryItem';
import Checkbox from 'settings/page-elements/dropdown/Checkbox';

const WAITLIST_LEARN_MORE_URL = 'https://help.getslick.com/en/articles/2806215-setup-a-wait-list-column';

class AddStylistOnboarding extends React.Component {
  static defaultProps = {
    hideWaitlistSectionIfOneStylist: false,
    roles: [],
    roleId: null, // eslint-disable-line react/default-props-match-prop-types
    onPhoneNumberValid: alwaysNoop,
  };

  constructor(props) {
    super(props);

    const state = {
      roleDropdownModal: false,
      serves_as_waitlist: false,
      selfEmployed: false,
    };

    const { roles } = props;
    const { stylist } = props;
    const { role, role_id: roleId } = asObject(stylist);

    if (role) {
      state.selectedRole = role;
    } else if (isFullArray(roles)) {
      state.selectedRole = roles[0]; // eslint-disable-line prefer-destructuring
      if (roleId) {
        for (let i = 0; i < roles.length; i += 1) {
          if (roles[i].id === roleId) {
            state.selectedRole = roles[i];
          }
        }
      }
      this.props.onRoleChange(state.selectedRole.id);
    }

    state.serves_as_waitlist = fromAnyToBool(stylist.serves_as_waitlist);
    state.selfEmployed = fromAnyToBool(stylist.is_self_employed);

    this.state = state;
  }

  onRoleClick = () => void this.setState({ roleDropdownModal: true });
  onRoleDropdownClose = () => void this.setState({ roleDropdownModal: false });

  onRoleSelect = (item) => {
    let selectedRole;
    if (this.props.roles) {
      for (let i = 0; i < this.props.roles.length; i += 1) {
        if (this.props.roles[i].id === item.id) {
          selectedRole = this.props.roles[i];
          this.props.onRoleChange(this.props.roles[i].id);
          this.setState({ selectedRole, roleDropdownModal: false });
          break;
        }
      }
    }
  };

  setSelfEmployed = (selfEmployed) => {
    // only employed or self-employed can be ticked at once (ie one or the other)
    this.setState({ selfEmployed }, () => void this.props.onSelfEmployedChange(this.state.selfEmployed));
  };

  setWaitList = () =>
    void this.setState(
      { serves_as_waitlist: !this.state.serves_as_waitlist },
      () => void this.props.onWaitlistChange(this.state.serves_as_waitlist),
    );

  render() {
    const {
      roles,
      onPhoneChange,
      categoryExecutions,
      onPhoneNumberValid,
      onNameChange,
      onCategoryCheckboxChange,
      validateEmail,
      stylist,
      onServiceCheckboxChange,
      validateNameLength,
      categories,
      onEmailChange,
      validateName,
      hideWaitlistSectionIfOneStylist,
    } = this.props;
    const { selfEmployed, roleDropdownModal, selectedRole, serves_as_waitlist: servesAsWaitlist } = this.state;

    const items = roles
      ? roles.map(({ id, name }) => ({
          id,
          name,
          active: fromAnyToBool(asObject(selectedRole).id === id),
        }))
      : undefined;

    return (
      <div data-bem="AddStylistOnboarding">
        <div className="content obs-stylist-add-new-component">
          <div data-bem="AddStylistOnboarding__name" className="cfix t-container relative">
            <InputFieldContainer
              data={{
                id: 'StaffNameInput',
                label: 'Full Name',
                type: 'text',
                placeholder: 'Ava Blade',
                inputValue: stylist.user_name,
                inputMode: 'text',
              }}
              autoFocus
              onChangeHandler={onNameChange}
              validateBlur={validateName}
              validateChange={validateNameLength}
            />
            <TooltipForReceptionist where={IN.salon} />
          </div>

          <div data-bem="AddStylistOnboarding__phone" className="cfix t-container relative">
            <PhoneNumberInput
              data={{
                id: 'StaffPhoneInput',
                label: 'Mobile Number',
                type: 'tel',
                placeholder: '07775 332 200',
                inputValue: stylist.phone ? stylist.phone : '',
              }}
              onPhoneNumberChange={onPhoneChange}
              onPhoneNumberValid={(valid, value) => {
                if (onPhoneNumberValid) {
                  onPhoneNumberValid(valid, value);
                }
              }}
            />
            <TooltipForReceptionist where={IN.salon} />
          </div>

          <div data-bem="AddStylistOnboarding__email" className="cfix t-container relative">
            <InputFieldContainer
              data={{
                id: 'StaffEmailInput',
                label: 'Email Address',
                type: 'email',
                placeholder: 'name@salon.com',
                inputValue: stylist.email ? stylist.email : '',
                inputMode: 'email',
              }}
              onChangeHandler={onEmailChange}
              validateBlur={validateEmail}
            />
            <TooltipForReceptionist where={IN.salon} />
          </div>

          <div data-bem="AddStylistOnboarding__waitlist" className="wait-list">
            <h5>Employment type</h5>

            <div className="employment-type">
              <div className="wait-list-checkbox">
                <div className="label-div">
                  <label htmlFor="Employed">
                    <Checkbox
                      isChecked={!selfEmployed}
                      id="Employed"
                      onCheckboxClick={() => this.setSelfEmployed(false)}
                    />
                  </label>
                </div>
                <span>Employed</span>
              </div>

              <div className="wait-list-checkbox">
                <div className="label-div">
                  <label htmlFor="selfImployed">
                    <Checkbox
                      isChecked={selfEmployed}
                      id="selfImployed"
                      onCheckboxClick={() => this.setSelfEmployed(true)}
                    />
                  </label>
                </div>
                <span>Self-employed / chair renter</span>
              </div>
            </div>

            <div className={hideWaitlistSectionIfOneStylist || ''}>
              <div className="wait-list-checkbox">
                <div className="label-div">
                  <label htmlFor="waitlist">
                    <Checkbox isChecked={servesAsWaitlist} id="waitlist" onCheckboxClick={this.setWaitList} />
                  </label>
                </div>
                <span>Make this a waitlist</span>
              </div>

              <div className="wait-list-desc">
                <p className="color-red">
                  Please note: To enable an online waitlist you must have at least one column enabled for online booking
                  which is NOT a waitlist. You can block out this column with time-off if you only want the waitlist
                  column to be bookable
                </p>
                <p>
                  Appointments in a waitlist column will not be sent automated SMS confirmations or reminders. No
                  deposits will be taken for any online bookings made in a waitlist column. Once the booking has been
                  confirmed, please use Slick Pay to request a deposit manually
                </p>
                <p>
                  <a href={WAITLIST_LEARN_MORE_URL} target="_blank" rel="noopener noreferrer">
                    Click here
                  </a>{' '}
                  to learn more about waitlist columns.
                </p>
              </div>
            </div>
          </div>

          <div data-bem="AddStylistOnboarding__role" className="cfix t-container relative">
            {items && roleDropdownModal && (
              <DropdowonContainer
                title="Select Role"
                items={items}
                onClose={this.onRoleDropdownClose}
                onSelectItem={this.onRoleSelect}
              />
            )}
            <TooltipForReceptionist where={IN.salon} />
          </div>

          {selectedRole && (
            <div data-bem="AddStylistOnboarding__staff" className="cfix relative">
              <section className="role-banner">
                <span> JOB TITLE</span>
                <div className="role-banner-text">
                  <span className="emoji" role="img" aria-labelledby="lamp">
                    💡
                  </span>
                  <div>
                    Click the box below to change job title and services prices according to the prices that have been
                    set for this job title in <strong>Service prices & timings.</strong>
                  </div>
                </div>
              </section>
              <label htmlFor="StaffRoleSelect" className="settings-heading">
                <button
                  className="utl-full-width select-button"
                  id="StaffRoleSelect"
                  onClick={this.onRoleClick}
                  style={{ marginTop: 8 }}
                >
                  <span className="select-button-text">{selectedRole.name}</span>
                  <span className="select-button-icon">
                    <span className="ic-sml ic_expand_more_black" />
                  </span>
                </button>
              </label>
              <TooltipForReceptionist where={IN.roleDropdown} />
            </div>
          )}

          <div className="input-baseline" />

          <div className="input-prompt-hide">
            <span>Prompt/Error Message</span>
          </div>

          <div data-bem="AddStylistOnboarding__prices" className="settings-heading">
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label className="row">
              <section className="role-banner no-margin">
                <span>PRICE LIST</span>
                <div className="role-banner-text">
                  <span className="emoji" role="img" aria-labelledby="lamp">
                    💡
                  </span>
                  <div>
                    To manage which services are bookable online for this staff member, head to
                    <strong> Online booking & payments</strong> in the main menu.
                  </div>
                </div>
                <div className="role-banner-text" style={{ marginTop: '12px' }}>
                  <span className="emoji" role="img" aria-labelledby="lamp">
                    💡
                  </span>
                  <div>
                    To amend prices, head to <strong> Service prices & timings </strong> in the settings menu.
                  </div>
                </div>
              </section>
            </label>
          </div>

          {categories.map((category) => (
            <CategoryItem
              onCategoryCheckboxChange={onCategoryCheckboxChange}
              onServiceCheckboxChange={onServiceCheckboxChange}
              categoryExecutions={categoryExecutions}
              category={category}
              key={category.id}
              roleId={stylist.role ? stylist.role.id : 0}
              stylist={stylist}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default AddStylistOnboarding;
